import { render, staticRenderFns } from "./GetCustomerPay.vue?vue&type=template&id=70c2c9b8&scoped=true&"
import script from "./GetCustomerPay.vue?vue&type=script&lang=js&"
export * from "./GetCustomerPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2c9b8",
  null
  
)

export default component.exports